import { render, staticRenderFns } from "./CSCFormAnAnswer060X0001Dlg.vue?vue&type=template&id=76cb1c36"
import script from "./CSCFormAnAnswer060X0001Dlg.vue?vue&type=script&lang=js"
export * from "./CSCFormAnAnswer060X0001Dlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports